import React from 'react'
import JumpstartRaisingInvestment, { getServerSideProps } from '../jumpstart-mw-ri'

/**
 * The raising investment page sold as the trial, from 26 October 2026 at this address alone. Since 2 November
 * 2026 /jumpstart-mw-ri sells the trial itself, so this address serves the same page for the ads that still link
 * here, under its own intake source so those sign-ups keep their attribution and Brevo list.
 */
const JumpstartRaisingInvestmentTrial = () => <JumpstartRaisingInvestment source="jumpstart-mw-ri-trial" />

export { getServerSideProps }

export default JumpstartRaisingInvestmentTrial
